import { Component, Input } from '@angular/core';
import { AssetService } from '../../../services/asset.service';
import { DrawAction, DrawActionElement } from '../../../models/draw-action';
import { CircleDrawAction } from '../../../models/draw-actions/circle-draw-action';
import { FabricService } from '../../../services/fabric.service';
import { TriangleDrawAction } from '../../../models/draw-actions/triangle-draw-action';
import { RectDrawAction } from '../../../models/draw-actions/rect-draw-action';
import { FreehandDrawAction } from '../../../models/draw-actions/freehand-draw-action';
import { TextDrawAction } from '../../../models/draw-actions/text-draw-action';
import { LineDrawAction } from '../../../models/draw-actions/line-draw-action';
import { StampDrawAction } from '../../../models/draw-actions/stamp-draw-action';
import { CommunicationService } from '../../../services/communication.service';
import { Subscription } from 'rxjs';
import { ApplicationStateService } from '../../../services/application-state.service';
import { EditMoveableBookFeatureEvent } from '../../../utils/events/edit-moveable-book-feature-event';
import { TooltipUtils } from '../../../utils/tooltip-utils';
import { AssetPipe } from '../../../pipes/asset.pipe';
import { DrawModeColorPickerComponent } from '../../utils/color-picker/draw-mode-color-picker.component';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-draw-bar',
    templateUrl: './draw-bar.component.html',
    styleUrls: ['./draw-bar.component.scss'],
    standalone: true,
    imports: [
        AssetPipe,
        DrawModeColorPickerComponent,
        NgStyle
    ]
})
export class DrawBarComponent {

    @Input() isMobileVersion: boolean;

    drawActionElements = DrawActionElement;
    borderWidths = [1, 3, 5, 8, 10];
    thirdLayerSlug = undefined;

    subscriptions: Subscription;

    constructor(
        public fabricService: FabricService,
        private communicationService: CommunicationService,
        private applicationStateService: ApplicationStateService,
        private assetService: AssetService) {

        this.subscriptions = this.communicationService.drawModeColorChangedSource$.subscribe(() => {
            this.thirdLayerSlug = undefined;
        });
    }

    selectDrawingAction($event, drawActionElement: DrawActionElement, svgName?: string): void {

        this.thirdLayerSlug = undefined;

        if (this.fabricService.getCurrentDrawAction() &&
            this.fabricService.getCurrentDrawAction().drawActionElement === drawActionElement) {
            this.fabricService.setCurrentDrawAction(undefined);
            TooltipUtils.hideAllTooltips();

            return;
        }

        let newDrawAction: DrawAction;

        switch (drawActionElement) {
            case DrawActionElement.CIRCLE:
                newDrawAction = new CircleDrawAction();
                break;
            case DrawActionElement.TRIANGLE:
                newDrawAction = new TriangleDrawAction();
                break;
            case DrawActionElement.RECT:
                newDrawAction = new RectDrawAction();
                break;
            case DrawActionElement.FREEHAND:
                newDrawAction = new FreehandDrawAction();
                break;
            case DrawActionElement.TEXT:
                newDrawAction = new TextDrawAction();
                break;
            case DrawActionElement.LINE:
                newDrawAction = new LineDrawAction();
                break;
            case  DrawActionElement.STAMP:
                newDrawAction = new StampDrawAction(this.assetService.getUrl(`draw-mode/svgs/${svgName}`));
                break;
            default:
                // unknown DrawAction
                console.error('Unknown DrawAction');
        }

        this.fabricService.setCurrentDrawAction(newDrawAction);
    }

    selectThirdLayer(slug: string): void {
        TooltipUtils.hideAllTooltips();
        if (this.thirdLayerSlug === slug) {
            this.thirdLayerSlug = undefined;

            return;
        }

        this.thirdLayerSlug = slug;
    }

    selectBorderWidth(borderWidth: number): void {
        this.fabricService.setCurrentBorderWidth(borderWidth);
        this.thirdLayerSlug = undefined;
    }

    closeDrawBar(): void {
        this.fabricService.setCurrentDrawAction(undefined);
        this.applicationStateService.isPageEditable = false;
        this.applicationStateService.pageEditMode = undefined;
        this.communicationService.announceMoveableBookFeatureEdit(new EditMoveableBookFeatureEvent());
        // @ts-ignore
        bootstrap.Dropdown.getOrCreateInstance('#drawing-tools').hide();
    }
}
